var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-progress-linear',{staticStyle:{"z-index":"10"},attrs:{"active":_vm.$globalStore.loading,"indeterminate":"","top":"","color":"primary","background-color":"primary lighten-3","stripped":"","dark":""}})
}
var staticRenderFns = []

export { render, staticRenderFns }